import { PRICE_CONFIRM_KEY } from "src/pages/ProductDetailPage/ProductDetailPage.constant";

export const checkLocalStorage = () => {
  if (localStorage.getItem(PRICE_CONFIRM_KEY) === "true") {
    return true;
  }
  return false;
};
